import styled from '@emotion/styled'

import type { FC } from 'react'

import * as HeroRecipe from '@segment/matcha/recipes/Hero'

interface HeroImageProps {
  src: string
  alt: string
  width?: number
  height?: number
}

const HeroImage: FC<HeroImageProps> = ({ src, alt, width, height }) => {
  return (
    <Picture>
      <source type="image/webp" src={src} />
      <HeroRecipe.Image width={width} height={height} src={src} alt={alt} />
    </Picture>
  )
}

const Picture = styled.picture``
export default HeroImage
